import React from 'react';
import styled, { css } from 'styled-components';

interface Props {
  active: boolean;
  onClick: (e?: React.MouseEvent) => any;
}

export function Toggle({ active, onClick, ...props }: Props) {
  return (
    <Container active={active} onClick={onClick} {...props}>
      <Knob active={active} />
    </Container>
  );
}

const Container = styled.div<{ active: boolean }>`
  width: 51px;
  height: 31px;
  border-radius: 15.5px;
  padding: 2px 2px;
  background-color: ${({ active, theme }) => (active ? theme.primaryBlue : theme.lighterGray)};
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-out;
`;

const Knob = styled.div<{ active: boolean }>`
  width: 27px;
  height: 27px;
  box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.06), 0 3px 8px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  border-radius: 13.5px;
  position: relative;
  transition: all 0.2s ease-out;

  ${({ active }) =>
    active &&
    css`
      margin-left: calc(100% - 27px);
    `}
`;
